import type { AppDialogOptions, DialogAnswer, DialogKind } from './types';

type DialogImpl = ((opts: AppDialogOptions) => Promise<DialogAnswer>) | null;

let _impl: DialogImpl = null;

export function registerAppDialog(impl: DialogImpl): () => void {
  _impl = impl;
  return () => {
    if (_impl === impl) {
      _impl = null;
    }
  };
}

export function showAppDialog(opts: AppDialogOptions): Promise<DialogAnswer> {
  if (!_impl) {
    return Promise.reject(new Error('DialogHost not mounted'));
  }
  return _impl(opts);
}

export function confirmAsync(
  text: string,
  kind: DialogKind = 'Question',
): Promise<boolean> {
  return showAppDialog({ text, kind, mode: 'YesNo' }).then((answer) => answer === 'yes');
}

export function alertAsync(
  text: string,
  kind: DialogKind = 'Information',
): Promise<void> {
  return showAppDialog({ text, kind, mode: 'OK' }).then(() => undefined);
}
